import { get } from 'lodash-es';
import { getCurrentScreen } from './screen';
import { getFrame } from './project';
import * as statusBar from '../constants/statusBar';
export function getStatusBarUnderlayHeight(state) {
    return state.project.config.statusBar.screenNeedsMovedDown
        ? getStatusBarHeight(state)
        : 0;
}
export function getStatusBarUnderlayColor(state) {
    var screen = getCurrentScreen(state);
    return screen.colorSamples.statusBar;
}
export function getStatusBarTrimHeight(state) {
    return state.project.config.statusBar.trimHeight;
}
export function bodyNeedsDeviceHeight(state) {
    return get(state, 'project.config.statusBar.bodyNeedsDeviceHeight', false);
}
export function getStatusBarHeight(state) {
    return statusBar.getHeight(getFrame(state));
}
